import { render, staticRenderFns } from "./component-goods.vue?vue&type=template&id=0f7e45e0&scoped=true&"
import script from "./component-goods.vue?vue&type=script&lang=js&"
export * from "./component-goods.vue?vue&type=script&lang=js&"
import style0 from "./component-goods.vue?vue&type=style&index=0&id=0f7e45e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7e45e0",
  null
  
)

export default component.exports